const compose = (...fns) => fns.reduce((f, g) => (...args) => f(g(...args)))
const buildArray = compose(sortByFrequency,getPrizesFromPaytable);
const calcSize = compose(countPrizes,countOccurences);


/**
 * Class for wheels & sas model.
 */
export default function Model(options)
{
    Object.assign(this, options);
}

/**
 * Build the model from the prize array
 *
 * @param  {Array}   arr  The arr
 * @return {Object}  The model
 */
Model.prototype.build = function(betModel)
{
    const arr = buildArray(betModel);
    const size = calcSize(arr);

    const isWin = (size === 1);
    const hasSas = (size < 3 && arr[0] >= this.sasIndex);
    const wheels = buildWheels.call(this, arr, hasSas);

    return {
        isWin,
        wheels,
        hasSas,
    };
}

function buildWheels(arr, hasSas)
{
    return arr.map((index, i) =>
    {
        let isSas = (hasSas && i === 2);

        const sliceIndex = this.map[index - 1];

        const startDelay = this.startDelay * i;
        const startDuration = this.startDuration - startDelay;
        const startRevolutions = this.startRevolutions;

        const stopDelay = this.stopDelay * i;
        let stopDuration = (isSas)? this.sasDuration: this.stopDuration;
        let stopRevolutions = (isSas)? this.sasRevolutions: this.stopRevolutions;
        let bounceDegrees = (isSas) ? this.sasBounceDegrees: this.bounceDegrees;
        let bounceDuration = (isSas) ? this.sasBounceDuration: this.bounceDuration;

        let totalDuration = startDelay + startDuration + stopDelay + stopDuration + bounceDuration;
        totalDuration = Math.round(totalDuration * 100) / 100;

        return {
            index,
            sliceIndex,
            startDelay,
            startDuration,
            startRevolutions,
            stopDelay,
            stopDuration,
            stopRevolutions,
            bounceDegrees,
            bounceDuration,
            totalDuration,
            isSas,
        };
    });
}

function countDuplicates(obj, num)
{
    obj[num] = (++obj[num] || 1);
    return obj;
}

function countOccurences(arr)
{
    return arr.reduce(countDuplicates, {});
}

function getPrizesFromPaytable(betModel)
{
    let arr = [];

    if (betModel.ticket.winIndex > 0)
    {
        arr = [betModel.ticket.winIndex, betModel.ticket.winIndex, betModel.ticket.winIndex];
    }
    else
    {
        arr = betModel.ticket.matrixIndexes.slice(0, 3);
    }

    return arr;
}

/**
 * Sorts an array by its frequency
 *
 * @param  {Array}  array  The array
 * @return {Array}  Sorted array
 */
function sortByFrequency(array)
{
    const frequency = {};

    array.forEach((value) => { frequency[value] = 0; });

    const uniques = array.filter((value) =>
    {
        frequency[value] += 1;

        return (frequency[value] === 1);
    });

    array = uniques.sort((a, b) => frequency[b] - frequency[a]);

    while (array.length < 3)
    {
        array.unshift(array[0]);
    }

    return array;
}

function countPrizes(count)
{
    return Object.keys(count).length;
}



// WEBPACK FOOTER //
// ./themes/fq/model/wheel-model.js